import API from 'app/utils/apiClient';

import { toParams } from 'app/utils/url';

const getMyInfo = () => API.get('/users/me/');

const patchUserInfo = ({ ...info }) => API.patch('/users/me/', { ...info });

const unregisterUser = () => API.delete('/users/me/');

const postMessages = (type, messages, rating = null) =>
  API.post('/user-messages/', {
    type,
    messages,
    ...(rating ? { rating } : {}),
  });

const signOut = (deviceType = null) => API.post('/logout/', { deviceType });

const checkPromotions = () => API.post('/users/me/promotion/');

const getNotifications = (lastEvaluatedKey = null) => {
  const params = toParams({ lastEvaluatedKey });
  return API.get(`/messaging/notifications/?${params}`);
};

const getBlockedUsers = (page = 1) =>
  API.get(`/users/me/block-users/?page=${page}`);

// other users
const getUser = (id) => API.get(`/users/${id}/`);

const followUser = (id) => API.post(`/users/${id}/follow/`);

const getUserFollowers = (id, page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/users/${id}/followers/?${params}`);
};

const getUserFollowings = (id, page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/users/${id}/followings/?${params}`);
};

const toggleBlockUser = (id) => API.post(`/users/${id}/block/`);

const getFirebaseToken = () => API.get('/users/me/firebase/');

const getUsersMarketItems = (ids) =>
  API.get(`/users/market-item-inventories/?ids=${ids.join(',')}`);

const getUserFans = (id, userIds) =>
  API.get(`/users/${id}/fan-club/users-check/?user_ids=${userIds.join(',')}`);

const getUserSetting = (objectType, objectId) =>
  API.get(`/users/me/settings/${objectType}-${objectId}/`);

const postUserSetting = (objectType, objectId, dataKey, value) =>
  API.post('/users/me/settings/', {
    objectKey: `${objectType}-${objectId}`,
    dataKey,
    value,
  });

const u2uActivities = (event, targetUserId) =>
  API.post('/users/me/u2u-activities/', {
    event,
    targetUserId,
  });

// restriction
const getMyRestrictions = (page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/users/me/restrictions/?${params}`);
};

const getUserRestriction = (id) => API.get(`/users/${id}/restriction/`);

const getUserEmailVerify = () => API.get(`/users/me/email/verify/`);

// vouchers
const getMyVouchers = (effectType = 'ALL') => {
  const params = toParams({ effectType });
  return API.get(`/users/me/vouchers/?${params}`);
};

const getMyVoucherRecommendation = (usage, unappliedValue) => {
  const params = toParams({ usage, unappliedValue });
  return API.get(`/users/me/vouchers/recommendation/?${params}`);
};

const postVoucher = (data, voucherId) =>
  API.post(`/users/me/vouchers/${voucherId}/consume/`, { data });

export default {
  getMyInfo,
  patchUserInfo,
  unregisterUser,
  postMessages,
  signOut,
  checkPromotions,
  getNotifications,
  getBlockedUsers,
  // other users
  getUser,
  followUser,
  getUserFollowers,
  getUserFollowings,
  toggleBlockUser,
  getFirebaseToken,
  getUsersMarketItems,
  getUserFans,
  getUserSetting,
  postUserSetting,
  u2uActivities,
  // restriction
  getMyRestrictions,
  getUserRestriction,
  //email
  getUserEmailVerify,
  // vouchers
  getMyVouchers,
  getMyVoucherRecommendation,
  postVoucher,
};



// WEBPACK FOOTER //
// ./src/app/apis/user.js